<template>
        <CommonBox :title="titles[updateType]" @close="close" @submit="submit">
        <el-form ref="form" label-width="240px" :model="initForm" :rules="rules" >
            <span v-if="this.updateType === 'info'">
            <el-form-item label="Company Name" prop="CompanyName">
                <el-input v-model="initForm.CompanyName" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="Company Name" prop="CompanyName">
                    <el-input v-model="initForm.CompanyName"></el-input>
                </el-form-item>
            </span>

            <span v-if="this.updateType === 'info'">
            <el-form-item label="Country" prop="Country">
                <el-input v-model="initForm.Country" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="Country" prop="Country">
                    <el-input v-model="initForm.Country"></el-input>
                </el-form-item>
            </span>

            <span v-if="this.updateType === 'info'">
            <el-form-item label="Ordering Description" prop="OrderingDescription">
                <el-input v-model="initForm.OrderingDescription" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="Ordering Description" prop="OrderingDescription">
                    <el-input v-model="initForm.OrderingDescription"></el-input>
                </el-form-item>
            </span>

            <span v-if="this.updateType === 'info'">
            <el-form-item label="Required Shipment Date" prop="ExpectTime">
                <el-date-picker
                    v-model="initForm.ExpectTime"
                    type="date" :disabled="true">
                </el-date-picker>
            </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="Required Shipment Date" prop="ExpectTime">
                    <el-date-picker
                        :picker-options="pickerOptions"
                        v-model="initForm.ExpectTime"
                        type="date">
                    </el-date-picker>
                </el-form-item>
            </span>
            <br>
             <!-- 查看操作  显示手动编辑 -->
                <span v-if="this.updateType === 'info'&& initForm.Devices[0]">
                <template v-for="(item,index) in initForm.Devices"> 
                    <el-form-item :key="item.index" label="Product Model" :prop="'Devices.'+index+'.ProductNumber'" :rules="{
                    required: true, message: 'please enter a product model', trigger: 'blur'}">
                        <el-input v-model="item.ProductNumber" :disabled="true"></el-input>
                    </el-form-item>  

                    <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Number'" :rules="{
                    required: true, message: 'please enter a quantity', trigger: 'blur'}">
                        <el-input v-model="item.Number" :disabled="true"></el-input>
                    </el-form-item>  
                </template>
                </span>
                <!-- 编辑操作 显示手动编辑 -->
                <span v-else-if="this.updateType === 'edit'&& initForm.Devices[0]">
                    <template v-for="(item,index) in initForm.Devices">
                            <el-form-item :key="item.index" label="Product Model" :prop="'Devices.'+index+'.ProductNumber'" :rules="{
                            required: true, message: 'please enter a product model', trigger: 'blur'}">
                                <el-input v-model="item.ProductNumber"></el-input>
                            </el-form-item>  

                            <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Number'" :rules="{
                            required: true, message: 'please enter a quantity', trigger: 'blur'}">
                                <el-input v-model="item.Number"></el-input>
                            </el-form-item>  
                            <el-button :key="item.index" style="margin:0px 10px 20px 240px;" @click="deleteDevice(index)">-</el-button>
                        </template>
                        <el-button  @click="addDevice">+</el-button>
                </span>
                <!-- 查看操作  显示文件 -->
                <span v-else-if="this.updateType === 'info'&& initForm.Devices.length == 0 &&  initForm.FileName != ' '">
                    <div style="display:inline-block;width:calc(100% - 100px); margin:0 30px">
                        <i class="el-icon-document"></i>
                        <label style="top: 4px;" class="files" @click="download(initForm.FileName)" title="Download">{{initForm.FileName}}</label>
                    </div>
                </span>
                <!-- 编辑操作 显示文件/删除/删除后再次上传 -->
                <span v-else-if="this.updateType === 'edit'&& initForm.Devices.length == 0">                      
                    <div style="display:inline-block;width:calc(100% - 100px); margin:0 50px"  v-if="initForm.FileName != ' '">
                        <i class="el-icon-document"></i>
                        <label style="top: 4px;"  class="files" @click="download(initForm.FileName)" title="Download">{{initForm.FileName}}</label>
                        <el-button @click="deleteFile(initForm)" size="mini" type="danger" style="vertical-align: top;float:right;" icon="el-icon-delete" circle></el-button>
                    </div>
                    <div  v-else>
                        <input type="file"  id="file"   hidden   @change="selectFile"  />
                        <el-button  style="margin:15px 50px;"  type="primary" @click="btnChange">Select File</el-button>
                        <span v-if = "isSelectedFile">
                            <div style="display:inline-block;line-height:25px;width:calc(100% - 100px); margin:0px 50px"  @mouseover="mouseOver" @mouseleave="mouseLeave" :style="active">
                                <i class="el-icon-document"></i>
                                <label style="top: 4px;font-size:14px" >{{fileData.name}}</label>
                                <i class="el-icon-circle-close" style="line-height:25px;float:right;" @click="deleteSelectedFile()"></i>
                            </div>
                        </span>
                    </div>
                </span>
                <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe> 


             <!-- 添加操作 -->
            <span v-if="this.updateType === 'add'">
                
                <el-form-item   label-width="115px" > 
                    <label style="font-size:14px;">Please choose how you would like to add your order</label>
                <el-radio v-model="radio" label="1"><label @click="radio='1'" style="font-size:16px;">input models & quantity</label></el-radio>
                <el-radio v-model="radio" label="2"><label @click="radio='2'" style="font-size:16px;">upload PO file</label></el-radio>
                </el-form-item>
                <!-- 选择手动编辑 -->
                 <span v-if="this.radio === '1'">
                    <template v-for="(item,index) in initForm.Devices">
                        <el-form-item :key="item.index" label="Product Model" :prop="'Devices.'+index+'.ProductNumber'" :rules="{
                        required: true, message: 'please enter a product model', trigger: 'blur'}">
                            <el-input v-model="item.ProductNumber"></el-input>
                        </el-form-item>  

                        <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Number'" :rules="{
                        required: true, message: 'please enter a quantity', trigger: 'blur'}">
                            <el-input v-model="item.Number"></el-input>
                        </el-form-item>  
                        <el-button :key="item.index" style="margin:0px 10px 20px 240px;" @click="deleteDevice(index)">-</el-button>
                    </template>
                    <el-button  @click="addDevice">+</el-button>
                </span>
                <!-- 选择文件上传 -->
                <span v-else-if="this.radio === '2'" >
                    <input type="file"  id="file"   hidden   @change="selectFile"  />
                    <el-button  style="margin:15px 117px;"  size='small' type="primary" @click="btnChange">Select File</el-button>
                    <span v-if = "isSelectedFile">
                        <div style="display:inline-block;line-height:25px;width:calc(100% - 150px); margin:0px 117px"  @mouseover="mouseOver" @mouseleave="mouseLeave" :style="active">
                            <i class="el-icon-document"></i>
                            <label style="top: 4px;font-size:14px" >{{fileData.name}}</label>
                            <i class="el-icon-circle-close" style="line-height:25px;float:right;" @click="deleteSelectedFile()"></i>
                        </div>
                    </span>
                </span>
            </span>
            
        </el-form>

    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox1.vue";
import { formatDate } from "@/methods/date.js";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                add:"Add Ordering",
                edit:"Edit Ordering",
                info:"View Ordering"
            },
            radio:'1',
            iframeUrl:'',
            rules:{
                ExpectTime:[{type: 'date', required: true, message: 'Please select the time', trigger: 'change'}],
                OrderingDescription:[{ required: true, message: 'Please enter your ordering description', trigger: 'blur' }]
            },
            header:{},
            data:{},
            fileList:[],
            fileData:null,
            isSelectedFile:false,
            active:'',
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() < Date.now() - 8.64e7;   //禁用以前的日期，今天不禁用
                }
            }
        };
    },
    mounted () {
        this.header = {
            "x-auth-token":localStorage.getItem('producttoken')
        };
    },
    methods:{
        success (response) {
            if(response.code === 0) {
                this.$baseNotice.message(response.msg);
                this.$emit('close');
                this.$emit('update');
            }else{
                this.$baseNotice.message(response.msg,"error");
            }
        },
        close () {
            this.$emit('close');
            this.$emit('update');
        },
        beforeUpload (file) { 
            if(file.size > 800 * 1024 * 1024) {
                this.$message.error("The size of "+file.name+" exceeds 800M !");
                return false;
            }
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let form = Object.assign({},this.initForm);
                form.Devices = JSON.stringify(form.Devices);
                form.ExpectTime = formatDate(form.ExpectTime);
                let formData = new FormData();
                for(var key in form) {
                    formData.append(key,form[key]); 
                }
                if (this.initForm.Devices.length !== 0  && this.radio === '1')
                {   //选择手动编辑时
                    let methods = this.updateType === 'add' ? 'post' : 'put';
                    let url = this.updateType === 'add' ? 'addOrdering' : 'editOrdering';
                    this.$http[methods](url,form,(data)=>{
                        this.$baseNotice.message(data.msg);
                        this.$emit('close');
                        this.$emit('update');
                    });
                }
                else
                {   
                    //上传中 filedata为空，说明没有选择新的文件
                    if(this.fileData === null &&  this.updateType === 'add') {
                        this.$message.error('No files are selected!');
                        return;
                    }
                    //编辑中 initForm.FileName === ' ' ，说明删除了原始文件   filedata为空，说明没有选择新的文件
                    if( this.initForm.FileName === ' ' && this.fileData === null) {
                        this.$message.error('No files are selected!');
                        return;
                    }
                    formData.append('file',this.fileData);
                    let url = this.updateType === 'add' ? 'uploadFileOrdering' : 'editFileOrdering';
                    this.$http.post(url,formData,(data)=>{
                        this.$baseNotice.message(data.msg);
                        this.$emit('close');
                        this.$emit('update');
                    });
                    
                } 
            });
        },
        btnChange() {
            //清空另一选项
            this.initForm.Devices = [];  
            //跳转到文件选择按钮
            var file = document.getElementById('file');  
            //触发file按钮的选择文件事件
            file.click(); 
        },
        //若有选中的文件（change），则会触发该事件   若取消则不会触发
        selectFile() {  
            var file = document.getElementById('file'); 
            this.fileData =  file.files[0];
            this.isSelectedFile = true;
        },

        deleteSelectedFile() {    
            //删除选择的文件
            this.fileData = null;
            this.isSelectedFile = false;
        },
        addDevice () {
            this.$set(this.initForm.Devices,this.initForm.Devices.length,{
                ProductNumber:"",
                Number:""
            });
        },
        deleteDevice (index) {
            this.$delete(this.initForm.Devices,index);
        },
        clearDevice() {
            this.initForm.Devices = [];
        },
        download (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/ordering/${data}`;
            // console.log(this.iframeUrl)
        },
        deleteFile (val) {
            this.$baseNotice.messageBox("confirm",`Are you sure you want to delete the file : ${val.FileName}?`,"warning","warning")(()=>{
                this.$http.delete("deleteFileOrdering",{
                    ID:val.ID
                },(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.getFiles(val);
                });
            });
            
        },
        getFiles (val) {
            this.files = [];
            this.$http.get("getOrderingInfo",{ 
                ID:val.ID
            },(data)=>{
                this.initForm.FileName = data.data.FileName;
            });
        },
        mouseOver: function() {
            this.active = 'background-color: #F2F6FC';
        },
        mouseLeave: function () {
            this.active = '';
        }
    }
};
</script>
<style lang="less" scoped>

    .files{
        text-decoration:underline;
        cursor: pointer;
        &:hover{
            color:#03a9f4;
        }
    }
</style>